'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var PRICE_BILLING_UNITS = exports.PRICE_BILLING_UNITS = {
    month: 'month',
    year: 'year'
};

var INVOICE_STATUS = exports.INVOICE_STATUS = {
    RECEIVED: 'RECEIVED', // step 1: recieved invoice data from stripe
    SENT: 'SENT', // step 4: send email to customer
    PAID_IN_CREDIT: 'PAID_IN_CREDIT' };

var COUPON_DURATION = exports.COUPON_DURATION = {
    forever: 'forever',
    repeating: 'repeating',
    once: 'once'
};

var INVOICE_DUE_DAYS = exports.INVOICE_DUE_DAYS = 14;


//////////////////
// WEBPACK FOOTER
// ./src/common/payment/paymentConstants.js
// module id = 484
// module chunks = 0